import React from "react";
import { VStack } from "@chakra-ui/react";
import { Redactor } from "components";
import { useCurrentCase, deserialize } from "duck";
import { Signature, Procedures } from "./components";

const Disclaimers: React.FC = () => {
  const disclaimerText = useCurrentCase(medCase => medCase.data.disclaimerText);
  const parsed = new DOMParser().parseFromString(disclaimerText, "text/html");
  const initialValue = JSON.stringify(deserialize(parsed.body));

  return (
    <VStack spacing={6} alignItems="left">
      <Redactor value={initialValue} readOnly />
      <Procedures />
      <Signature />
    </VStack>
  );
};

export default Disclaimers;
